import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Martín', 'Diego', 'Laura', 'Alejandro', 'Javier', 'Facundo', 'Camila', 'Tomás', 'Lucas', 'Sofía'];
const cities = ['Rosario', 'Córdoba', 'Mendoza', 'CABA', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Bahía Blanca', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5s
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Then interval every 15-25 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-167">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-dark-800 border border-lime-400/30 rounded-lg p-4 shadow-2xl shadow-lime-400/10 max-w-sm flex items-start space-x-3" data-id="element-168">
          <CheckCircle2 className="w-6 h-6 text-lime-400 flex-shrink-0 mt-0.5" data-id="element-169" />
          <div data-id="element-170">
            <p className="text-sm text-gray-200" data-id="element-171">
              <span className="font-bold text-white" data-id="element-172">{buyer.name}</span> de{' '}
              {buyer.city} acaba de comprar este libro digital.
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-173">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}